var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2a9.77 9.77 0 018.82 5.5A9.77 9.77 0 0111 13a9.77 9.77 0 01-8.82-5.5A9.77 9.77 0 0111 2zm0-2C6 0 1.73 3.11 0 7.5 1.73 11.89 6 15 11 15s9.27-3.11 11-7.5C20.27 3.11 16 0 11 0zm0 3C8.52 3 6.5 5.02 6.5 7.5S8.52 12 11 12s4.5-2.02 4.5-4.5S13.48 3 11 3z",
    fill: "url(#eyeIcon_svg__paint0_linear_1036_231)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eyeIcon_svg__paint0_linear_1036_231",
    x1: 12.294,
    y1: 28.171,
    x2: 27.317,
    y2: 18.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#218FEE"
  })))));
}

export default SvgEyeIcon;